<div style="background: white; border: 1px solid #e5e7eb; border-radius: 16px; padding: 20px; margin-bottom: 16px;">
  <h3 style="font-size: 0.95rem; font-weight: 700; color: #1e5a3f; margin: 0 0 16px;">Resumen de operación</h3>

  <!-- Beneficiario -->
  <div style="padding-bottom: 14px; border-bottom: 1px solid #e5e7eb; margin-bottom: 14px;">
    <span style="font-size: 0.72rem; color: #6b7280; font-weight: 500;">Beneficiario</span>
    <p style="font-size: 0.88rem; font-weight: 600; color: #1e5a3f; margin: 2px 0 0;">
      {{ beneficiario?.beneficiario_nombre }} {{ beneficiario?.beneficiario_apellido }}
    </p>
  </div>

  <!-- Montos -->
  <div class="grid grid-cols-1 sm:grid-cols-2 gap-3" style="margin-bottom: 14px;">
    <div style="background: #f0fdf4; border: 1px solid #bbf7d0; border-radius: 12px; padding: 14px; text-align: center;">
      <span style="font-size: 0.7rem; color: #6b7280; font-weight: 500; text-transform: uppercase;">Tú envías</span>
      <p style="font-size: 1.2rem; font-weight: 800; color: #1e5a3f; margin: 4px 0 6px;">{{ clpCurrency | currency:'':'':'1.0-0' }}</p>
      <span style="display: inline-flex; align-items: center; gap: 4px; background: white; padding: 3px 10px; border-radius: 12px; font-size: 0.72rem; font-weight: 600; color: #1e5a3f;">
        <img src="assets/flags/chile.png" alt="CLP" style="width: 16px; height: 16px; border-radius: 50%; object-fit: cover;">
        CLP
      </span>
    </div>
    <div style="background: #f0fdf4; border: 1px solid #bbf7d0; border-radius: 12px; padding: 14px; text-align: center;">
      <span style="font-size: 0.7rem; color: #6b7280; font-weight: 500; text-transform: uppercase;">Destinatario recibe</span>
      <p style="font-size: 1.2rem; font-weight: 800; color: #1e5a3f; margin: 4px 0 6px;">{{ usdCurrency | currency:'':'':'1.2-2' }}</p>
      <span style="display: inline-flex; align-items: center; gap: 4px; background: white; padding: 3px 10px; border-radius: 12px; font-size: 0.72rem; font-weight: 600; color: #1e5a3f;">
        <img src="assets/icons/USDT_Logo.png" alt="USDT" style="width: 16px; height: 16px; border-radius: 50%; object-fit: cover;">
        USDT
      </span>
    </div>
  </div>

  <!-- Detalles -->
  <div style="display: flex; align-items: center; gap: 8px; padding: 10px 0; border-bottom: 1px solid #e5e7eb;">
    <mat-icon style="font-size: 16px; width: 16px; height: 16px; flex-shrink: 0; color: #1C593D;">currency_exchange</mat-icon>
    <span style="flex: 1; font-size: 0.78rem; color: #6b7280;">Tasa USDT/CLP:</span>
    <span style="font-size: 0.78rem; font-weight: 700; color: #1e5a3f;">{{ usdt_clp_tax | number:'1.0-2' }}</span>
  </div>
  <div *ngIf="beneficiario" style="display: flex; align-items: center; gap: 8px; padding: 10px 0; border-bottom: 1px solid #e5e7eb;">
    <mat-icon style="font-size: 16px; width: 16px; height: 16px; flex-shrink: 0; color: #1C593D;">hub</mat-icon>
    <span style="flex: 1; font-size: 0.78rem; color: #6b7280;">Red:</span>
    <span style="font-size: 0.78rem; font-weight: 700; color: #1e5a3f;">{{ redBeneficiario }}</span>
  </div>
  <div style="display: flex; align-items: center; gap: 8px; padding: 10px 0;">
    <mat-icon style="font-size: 16px; width: 16px; height: 16px; flex-shrink: 0; color: #1C593D;">send</mat-icon>
    <span style="flex: 1; font-size: 0.78rem; color: #6b7280;">Dirección de retiro:</span>
    <span style="font-size: 0.78rem; font-weight: 700; color: #1e5a3f; font-family: monospace; word-break: break-all; max-width: 200px; text-align: right;">
      {{ beneficiario?.beneficiario_medio_recepcion }}
    </span>
  </div>
</div>

<!-- Action buttons -->
<div class="step-actions">
  <button type="button" (click)="confirmarEnvio()"
    style="width: 100%; display: flex; align-items: center; justify-content: center; gap: 8px; padding: 14px; background: #1C593D; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.95rem; cursor: pointer; transition: background 0.2s;"
    onmouseover="this.style.background='#059669'" onmouseout="this.style.background='#1C593D'">
    <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: white;">check_circle</mat-icon>
    Enviar transacción
  </button>

  <button type="button" (click)="goToBack()"
    style="width: 100%; display: flex; align-items: center; justify-content: center; gap: 6px; padding: 12px; margin-top: 10px; background: white; color: #374151; border: 1px solid #d1d5db; border-radius: 10px; font-weight: 600; font-size: 0.88rem; cursor: pointer; transition: background 0.2s;"
    onmouseover="this.style.background='#f3f4f6'" onmouseout="this.style.background='white'">
    <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: #374151;">arrow_back</mat-icon>
    Volver
  </button>
</div>
